var map = {
	"./en_in.json": "f149",
	"./en_kn.json": "64f5",
	"./en_mr.json": "e54b",
	"./en_ms.json": "d29b",
	"./en_te.json": "527f",
	"./en_us.json": "cf6f",
	"./es_es.json": "9fdd",
	"./es_mx.json": "7970",
	"./gu_in.json": "1a20",
	"./hi_in.json": "cfc37",
	"./id_id.json": "090a",
	"./kn_in.json": "028a",
	"./ms_my.json": "800a",
	"./pt_BR.json": "0c31",
	"./ta_in.json": "2060",
	"./th_th.json": "d968",
	"./vi_vn.json": "afd6",
	"./zh_cn.json": "eadb",
	"./zh_hk.json": "806c",
	"./zh_tw.json": "056c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";